import {BUSCAR_MANUTENCOES_VEICULO, CADASTRAR_REGITRO_MANUTENCAO_VEICULO, SELECIONAR_MANUTENCAO_VEICULO, ATUALIZAR_REGITRO_MANUTENCAO_VEICULO, EXCLUIR_MANUTENCAO_VEICULO, ALTERAR_DETALHAMENTO_MANUTENCAO_VEICULO} from '../../actions/types'

const initial = {
  manutencoesVeiculo: [],
  manutencaoVeiculoSelecionado: {}
};

export default function reducerBuscarManutencoesVeiculo (state = initial, action) {
  switch (action.type) {

    case BUSCAR_MANUTENCOES_VEICULO: {
      if (action.payload.manutencoesVeiculo) {
        const manutencoesVeiculo = action.payload.manutencoesVeiculo.manutencoesVeiculo.map(manutencaoVeiculo => Object.assign({}, manutencaoVeiculo, { exibirDetalhe: false, selecionado: false }));
        return {
          ...state,
          manutencoesVeiculo,
          total: action.payload.manutencoesVeiculo.total
        }
      }
      return state
    }

    case CADASTRAR_REGITRO_MANUTENCAO_VEICULO: {      
      const manutencaoVeiculo = action.payload.data;      
      let manutencoesVeiculo = Object.assign([], state.manutencoesVeiculo);

      if (manutencaoVeiculo) {
        manutencoesVeiculo.push(manutencaoVeiculo);        
        manutencoesVeiculo = ordernarColecaoManutencoesVeiculoPorDataOcorrencia(manutencoesVeiculo);
      }

      return {
        ...state,
        manutencoesVeiculo
      }

    }

    case ATUALIZAR_REGITRO_MANUTENCAO_VEICULO: {
      const manutencaoVeiculoAtualizado = action.payload.data;      
      let manutencoesVeiculo = Object.assign([], state.manutencoesVeiculo);

      if (manutencaoVeiculoAtualizado) {
        manutencoesVeiculo = manutencoesVeiculo.map(it => Object.assign({}, it, { selecionado: false, exibirDetalhe: false }));
        const manutencaoVeiculo = state.manutencoesVeiculo.find(it => it.id == manutencaoVeiculoAtualizado.id);
        
        if (manutencaoVeiculo) {          
          const indice = state.manutencoesVeiculo.indexOf(manutencaoVeiculo);
          const novoManutencaoVeiculo = Object.assign({}, manutencaoVeiculoAtualizado, { selecionado: false, exibirDetalhe: false });
          manutencoesVeiculo[indice] = novoManutencaoVeiculo;
          manutencoesVeiculo = ordernarColecaoManutencoesVeiculoPorDataOcorrencia(manutencoesVeiculo);

          return {
            ...state,
            manutencoesVeiculo,
            manutencaoVeiculoSelecionado: {}
          };
        }
      }

      return {
        ...state,
        manutencoesVeiculo
      }
    }

    case EXCLUIR_MANUTENCAO_VEICULO: {      
      if (action.payload.data) {        
        const idManutencaoVeiculo = action.payload.data;        
        
        let manutencoesVeiculo = Object.assign([], state.manutencoesVeiculo);
        manutencoesVeiculo = manutencoesVeiculo.filter(it => it.id != idManutencaoVeiculo);
        
        if (manutencoesVeiculo.length > 0) {
          manutencoesVeiculo = manutencoesVeiculo.map(it => Object.assign({}, it, { exibirDetalhe: false, selecionado: false }));
          manutencoesVeiculo = ordernarColecaoManutencoesVeiculoPorDataOcorrencia(manutencoesVeiculo);

         return {
          ...state,                    
          manutencoesVeiculo,
          manutencaoVeiculoSelecionado: {}
         }
        }
      }

      return {
        ...state,                    
        manutencaoVeiculoSelecionado: {}
      };
    }

    case SELECIONAR_MANUTENCAO_VEICULO: {
      if (action.payload) {
        const manutencaoVeiculo = action.payload;
        const indice = state.manutencoesVeiculo.indexOf(manutencaoVeiculo);
        const novoManutencaoVeiculo = Object.assign({}, manutencaoVeiculo, {  selecionado: !manutencaoVeiculo.selecionado });
        let manutencoesVeiculo = Object.assign([], state.manutencoesVeiculo);
        manutencoesVeiculo = manutencoesVeiculo.map(it => Object.assign({}, it, { exibirDetalhe: false, selecionado: false }));
        manutencoesVeiculo[indice] = novoManutencaoVeiculo;

        return {
          ...state,
          manutencoesVeiculo,
          manutencaoVeiculoSelecionado: action.payload          
        };
      }

      let manutencoesVeiculo = Object.assign([], state.manutencoesVeiculo);        
      manutencoesVeiculo = manutencoesVeiculo.map(it => Object.assign({}, it, { selecionado: false }));

      return {
        ...state,
        manutencoesVeiculo,
        manutencaoVeiculoSelecionado: {}
      };
    }

    case ALTERAR_DETALHAMENTO_MANUTENCAO_VEICULO: {
      const manutencaoVeiculo = action.payload;
      const indice = state.manutencoesVeiculo.indexOf(manutencaoVeiculo);
      const novoManutencaoVeiculo= Object.assign({}, manutencaoVeiculo, { exibirDetalhe: !manutencaoVeiculo.exibirDetalhe });
      const manutencoesVeiculo = Object.assign([], state.manutencoesVeiculo);
      manutencoesVeiculo[indice] = novoManutencaoVeiculo;

      return {
        ...state,
        manutencoesVeiculo,        
      };
    }

    default: {
      return state
    }
  }

  function ordernarColecaoManutencoesVeiculoPorDataOcorrencia(manutencoesVeiculo) {
    return manutencoesVeiculo.sort((a, b) => new Date(b.dataOcorrencia) - new Date(a.dataOcorrencia));
  }
}
